import React, { useEffect, useState } from 'react';
import { Layers, BarChart3, Zap } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const rotatingWords = ['marketing', 'product', 'revops', 'research', 'growth', 'sales', 'design'];
export function FeaturesSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % rotatingWords.length);
    }, 2500);
    return () => clearInterval(interval);
  }, []);
  return <section className="w-full bg-[#F5F4F1] pt-12 pb-24 px-4" data-id="element-38">
      <div className="max-w-5xl mx-auto" data-id="element-39">
        {/* Section Statement - moved above features, right below hero CTA */}
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-40">
          <h2 className="text-3xl md:text-[2.75rem] font-medium tracking-tight text-[#0F0F0F] leading-[1.1] mb-5" data-id="element-41">
            Made for modern{' '}
            <span className="inline-flex items-center justify-center overflow-hidden border border-dashed border-[#D0CEC9] rounded-lg px-2 py-1" style={{
            width: '165px',
            height: '1.3em'
          }} data-id="element-42">
              <AnimatePresence mode="wait" data-id="element-43">
                <motion.span key={rotatingWords[currentIndex]} initial={{
                y: '100%',
                opacity: 0
              }} animate={{
                y: '0%',
                opacity: 1
              }} exit={{
                y: '-100%',
                opacity: 0
              }} transition={{
                duration: 0.45,
                ease: [0.25, 0.1, 0.25, 1]
              }} className="inline-block text-[#0F0F0F]" data-id="element-44">
                  {rotatingWords[currentIndex]}
                </motion.span>
              </AnimatePresence>
            </span>{' '}
            teams
          </h2>
          <p className="text-[#5C5C5C] text-[12px]" data-id="element-45">
            Add your prompts and competitors. Andoe analyzes the signals and
            prioritizes what to improve.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-46">
          {/* Feature 1 */}
          <div className="p-8 rounded-2xl bg-[#FDFCFB] border border-[#E8E6E3] shadow-[0_2px_8px_rgba(0,0,0,0.02)]" data-id="element-47">
            <div className="mb-6 inline-flex items-center justify-center w-12 h-12 rounded-xl bg-[#FAF9F7] border border-[#E8E6E3]" data-id="element-48">
              <Layers className="w-6 h-6 text-[#1A1A1A]" data-id="element-49" />
            </div>
            <h3 className="text-xl font-medium text-[#0F0F0F] tracking-tight" data-id="element-50">
              Your prompts are strategy
            </h3>
            <p className="mt-2 text-[13px] text-[#8A8A8A] leading-relaxed" data-id="element-51">
              Design, group, and manage prompts around your customer intent.
            </p>
          </div>

          {/* Feature 2 */}
          <div className="p-8 rounded-2xl bg-[#FDFCFB] border border-[#E8E6E3] shadow-[0_2px_8px_rgba(0,0,0,0.02)]" data-id="element-52">
            <div className="mb-6 inline-flex items-center justify-center w-12 h-12 rounded-xl bg-[#FAF9F7] border border-[#E8E6E3]" data-id="element-53">
              <BarChart3 className="w-6 h-6 text-[#1A1A1A]" data-id="element-54" />
            </div>
            <h3 className="text-xl font-medium text-[#0F0F0F] tracking-tight" data-id="element-55">
              Monitor your competitors
            </h3>
            <p className="mt-2 text-[13px] text-[#8A8A8A] leading-relaxed" data-id="element-56">
              See how competitors appear when customers ask questions.
            </p>
          </div>

          {/* Feature 3 */}
          <div className="p-8 rounded-2xl bg-[#FDFCFB] border border-[#E8E6E3] shadow-[0_2px_8px_rgba(0,0,0,0.02)]" data-id="element-57">
            <div className="mb-6 inline-flex items-center justify-center w-12 h-12 rounded-xl bg-[#FAF9F7] border border-[#E8E6E3]" data-id="element-58">
              <Zap className="w-6 h-6 text-[#1A1A1A]" data-id="element-59" />
            </div>
            <h3 className="text-xl font-medium text-[#0F0F0F] tracking-tight" data-id="element-60">
              Agentic analytics
            </h3>
            <p className="mt-2 text-[13px] text-[#8A8A8A] leading-relaxed" data-id="element-61">
              Andoe AI agent proactively analyze across your prompt data and
              share insights.
            </p>
          </div>
        </div>
      </div>
    </section>;
}